export default __webpack_public_path__ + "static/media/date.fe6f53e1.svg";